
import Vue from "vue"
import { mapGetters } from "vuex"

export default Vue.extend({
  data: () => ({
    title: "Итоги",
    links: {
      ВИДЕО: "https://vk.com/video/@rif_ru",
      ФОТО: "https://vk.com/albums-36099097",
      НОВОСТИ: "/news",
      СПИКЕРЫ: "/speakers",
      "TG-КАНАЛ": "https://t.me/rif_cib",
    },
  }),

  head () {
    return { title: this.getTitle(this.title) }
  },

  computed: {
    ...mapGetters("app", ["getTitle"]),
  },
})
